// Sdílená normalizace a validace URL pro všechny vstupy v aplikaci.

/**
 * Opraví poškozené/duplicitní scheme prefixy (https//, https://https//, chybějící dvojtečku)
 * a doplní scheme. Nepoškodí domény začínající na „http" (httpbin.org) — za scheme vyžaduje „:" nebo „/".
 */
export function normalizeUrlInput(raw: string): string {
  const u = (raw || '').trim()
  if (!u) return u
  const scheme = /^http[:/]/i.test(u) ? 'http' : 'https'
  const rest = u.replace(/^(https?[:/]+)+/i, '').replace(/^\/+/, '')
  return `${scheme}://${rest}`
}

/** Vrátí jen host (bez scheme, www a cesty) — pro porovnání/validaci domény. */
export function extractHost(raw: string): string {
  try {
    return new URL(normalizeUrlInput(raw)).hostname.replace(/^www\./i, '')
  } catch {
    return (raw || '').trim().replace(/^https?:\/\//i, '').replace(/^www\./i, '').split(/[/?#]/)[0]
  }
}

/**
 * Je to platná URL/doména? Host musí mít aspoň jednu tečku a TLD (2+ znaky).
 * Akceptuje „example.com", „www.sub.example.co.uk", „https://example.com/path".
 * Odmítne „abc", prázdno, „http://", „localhost", IP bez TLD apod.
 */
export function isValidUrl(raw: string): boolean {
  const u = (raw || '').trim()
  if (!u) return false
  try {
    const parsed = new URL(normalizeUrlInput(u))
    return /^([a-z0-9](-?[a-z0-9])*\.)+[a-z]{2,}$/i.test(parsed.hostname)
  } catch {
    return false
  }
}
